export default {"src":"https://images-cdn.curipod.com/d-c4aa2ae1/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};